
import { UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxHeaderModule } from '@aposin/ng-aquila/header';
import { NxLinkModule } from '@aposin/ng-aquila/link';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { isLocalEnvironment } from '../../utils/environment.utils';
import { AccessibilityModule } from '../accessibility/accessibility.module';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    NxHeaderModule,
    NxLinkModule,
    NxButtonModule,
    AccessibilityModule,
    RouterModule,
    UpperCasePipe
],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  private oauthService = inject(OAuthService);
  private router = inject(Router);

  isLocalEnvironment = isLocalEnvironment();
  currentEnvironment = environment.environment;
  isNonProdEnvironment = ['local', 'dev02', 'uatr', 'uatm', 'proddre'].includes(this.currentEnvironment);

  logout() {
    this.oauthService.logOut();
    this.router.navigate(['/']);
  }
}
